import { MoonFilled } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../providers/auth.provider";
import { useTheme } from "../../providers/theme.provider";
import LogoComponent from "./logo.component";
import { useLayoutContext } from "../../providers/layout.provider";

export default function Header() {
  const { user, signout } = useAuthContext();
  const navigate = useNavigate();
  const { isMobile } = useLayoutContext();
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);
  const { toggleTheme, theme } = useTheme();

  const fontSize = isMobile ? "3vw" : "1.5vw";

  const handleLogout = () => {
    signout();
    navigate("/login");
  };

  return (
    <div className="bg-purple">
      <div className="divSpread divAlignItemsOnly">
        <LogoComponent isAuthenticated={!!user} />

        <Flex className="divAlignItemsOnly" gap={5} style={{ marginRight: 10 }}>
          {!!user && (
            <Flex>
              <Button
                icon={
                  <MoonFilled
                    style={{
                      color: theme === "light" ? "black" : "white",
                      backgroundColor: "inherit",
                    }}
                  />
                }
                type="text"
                onClick={() => {
                  setIsDarkMode(!isDarkMode);
                  toggleTheme();
                }}
              ></Button>

              <Button
                onClick={() => handleLogout()}
                style={{ backgroundColor: "inherit" }}
                type="text"
              >
                Logout
              </Button>
            </Flex>
          )}

          {!user && (
            <Flex gap={10} className="divAlignItemsOnly">
              <Link
                to={"/pricing"}
                style={{
                  backgroundColor: "inherit",
                  fontWeight: "normal",
                  color: "white",
                  fontSize,
                }}
              >
                Pricing
              </Link>

              <span style={{ color: "white" }}>|</span>
              <Link
                to={"/register"}
                style={{
                  backgroundColor: "inherit",
                  fontWeight: "normal",
                  color: "white",
                  fontSize,
                }}
              >
                Register
              </Link>
              <span style={{ color: "white" }}>|</span>
              <Link
                to={"/login"}
                style={{
                  backgroundColor: "inherit",
                  fontWeight: "normal",
                  color: "white",
                  fontSize,
                }}
              >
                Login
              </Link>
            </Flex>
          )}
        </Flex>
      </div>
    </div>
  );
}
